export enum LearnerStatusEnum {
    GRADUATED = 'Graduated',
    GRADUATED_BO_KHOA = 'Graduated - bỏ khoá',
    GRADUATED_CHUYEN_NHUONG = 'Graduated - chuyển nhượng',
    HIBERNATED_BO_KHOA = 'Hibernated - bỏ khoá',
    ACTIVE = 'Active',
    BAO_LUU = 'Bảo lưu',
    PENDING_CHUYEN_NHUONG = 'Pending - chuyển nhượng',
    PENDING_CHUYEN_DOI = 'Pending - chuyển đổi',
    PENDING_HV_LHE_LAI = 'Pending - HV lhe lại',
    PENDING_CONDITION = 'Pending - condition',
    CANCEL = 'Cancel',
    DONE = 'Done',
    THU = 'Thử'
}

export const LEARNER_STATUS_CONFIG = {
    [LearnerStatusEnum.GRADUATED]: {
        label: 'Graduated',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [LearnerStatusEnum.GRADUATED_BO_KHOA]: {
        label: 'Graduated - bỏ khoá',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    },
    [LearnerStatusEnum.GRADUATED_CHUYEN_NHUONG]: {
        label: 'Graduated - chuyển nhượng',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    },
    [LearnerStatusEnum.HIBERNATED_BO_KHOA]: {
        label: 'Hibernated - bỏ khoá',
        cssClass: 'text-sm !bg-gray-200 !text-gray-600'
    },
    [LearnerStatusEnum.ACTIVE]: {
        label: 'Active',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    },
    [LearnerStatusEnum.BAO_LUU]: {
        label: 'Bảo lưu',
        cssClass: 'text-sm !bg-purple-100 !text-purple-700'
    },
    [LearnerStatusEnum.PENDING_CHUYEN_NHUONG]: {
        label: 'Pending - chuyển nhượng',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-700'
    },
    [LearnerStatusEnum.PENDING_CHUYEN_DOI]: {
        label: 'Pending - chuyển đổi',
        cssClass: 'text-sm !bg-orange-100 !text-orange-700'
    },
    [LearnerStatusEnum.PENDING_HV_LHE_LAI]: {
        label: 'Pending - HV lhe lại',
        cssClass: 'text-sm !bg-yellow-200 !text-yellow-800'
    },
    [LearnerStatusEnum.PENDING_CONDITION]: {
        label: 'Pending - condition',
        cssClass: 'text-sm !bg-amber-100 !text-amber-700'
    },
    [LearnerStatusEnum.CANCEL]: {
        label: 'Cancel',
        cssClass: 'text-sm !bg-red-100 !text-red-700'
    },
    [LearnerStatusEnum.DONE]: {
        label: 'Done',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [LearnerStatusEnum.THU]: {
        label: 'Thử',
        cssClass: 'text-sm !bg-cyan-100 !text-cyan-700'
    }
};
